export { initGameShell } from './initGameShell';
export type { GameShellOptions } from './initGameShell';
export { startFit, GS_RESIZE_EVENT, GS_VH_VAR } from './fit/fit';
export type { GsResizeDetail } from './fit/fit';
export { startInstall, DEFAULT_SNOOZE_DAYS } from './install/install';
export type { InstallOptions, BeforeInstallPromptEvent } from './install/install';
export { CardPlacement } from './install/CardPlacement';
export { isStandalone, isIosSafari, isDesktop, DESKTOP_MIN_WIDTH } from './install/platform';
export { startCrash } from './crash/crash';
export type { CrashOptions } from './crash/crash';
export { CRASH_KIND } from './crash/crashKind';
export type { CrashInfo, CrashKind } from './crash/crashKind';
export { startLifecycle, unlockAudio, prefersReducedMotion } from './lifecycle/lifecycle';
export type { LifecycleOptions, ResumableAudio } from './lifecycle/lifecycle';
export { startVersionPoll } from './version/versionPoll';
export type { VersionPollOptions } from './version/versionPoll';
export { startIdleGate, DEFAULT_IDLE_MAX_WAIT_MS, WHEN_IDLE_GLOBAL } from './idle/whenIdle';
export type { IdleGate, IdleGateOptions, WhenIdle, WhenIdleWindow } from './idle/whenIdle';
export { GAME_SHELL_CSS, injectStyles } from './styles';
export type { Disposable, GameShellHandle, PlayingHandle, GameShellLabels, InstallLabels, CrashLabels } from './types';
